import styled from "styled-components"
import { motion } from "framer-motion"
import { IconButton } from "@material-ui/core"
import Light1Icon from "./light_1_placeholder.jpg"
import Light2Icon from "./light_2_placeholder.jpg"
import Light3Icon from "./light_3_placeholder.jpg"
import Light4Icon from "./light_4_placeholder.jpg"
import Dark1Icon from "./dark_1_placeholder.jpg"
import Dark2Icon from "./dark_2_placeholder.jpg"
import Dark3Icon from "./dark_3_placeholder.jpg"
import Dark4Icon from "./dark_4_placeholder.jpg"

export const Title = styled.p`
  font-family: NewParisKingSize-Regular;
  font-size: 5.5vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
  margin-bottom: 2vw;
`

export const Label = styled.p`
  font-family: AzoSans-Regular;
  font-size: 0.7vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
  margin-bottom: 0.7vw;
  width: 45%;
  line-height: 130%;
  min-width: 350px;
`

export const Title1 = styled.p`
  font-family: Lora-Regular;
  font-size: 5.5vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
`

export const Label1 = styled.p`
  font-family: AzoSans-Regular;
  font-size: 0.7vw;
  color: ${({ color }) => color};
  padding: 0;
  margin: 0;
  margin-bottom: 0.7vw;
  width: 45%;
  line-height: 130%;
  min-width: 350px;
  text-align: right;
`

export const Holder = styled(motion.div)`
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  display: inline-flex;
`
export const LightHolder = styled.div`
  width: 50%;
  height: 100%;
  padding: 3vw 4vw 10vw 0;
  position: relative;
`

export const LightBgHolder = styled.div`
  width: 100%;
  height: 100%;
  background-color: #9db7ad;
  padding: 4vw 2vw;
`
export const LightPH1 = styled.div`
  position: absolute;
  bottom: 7vw;
  left: 20%;
  z-index: 1;
  width: 16.7vw;
  height: 13.7vw;
  background-image: url(${Light1Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateX(-20px);
  }
`
export const LightPH2 = styled.div`
  position: absolute;
  bottom: 10vw;
  left: 58%;
  z-index: 2;
  width: 13.5vw;
  height: 17vw;
  background-image: url(${Light2Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateX(20px);
  }
`
export const LightPH3 = styled.div`
  position: absolute;
  bottom: 16vw;
  left: 37%;
  z-index: 3;
  width: 15vw;
  height: 15vw;
  background-image: url(${Light3Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateY(-20px);
  }
`
export const LightPH4 = styled.div`
  position: absolute;
  bottom: 5vw;
  left: 48%;
  z-index: 4;
  width: 13.5vw;
  height: 13.5vw;
  background-image: url(${Light4Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateY(20px);
  }
`

export const DarkHolder = styled.div`
  width: 50%;
  height: 100%;
  padding: 10vw 0 3vw 4vw;
  position: relative;
`

export const DarkBgHolder = styled.div`
  width: 100%;
  height: 100%;
  background-color: #667977;
  padding: 4vw 2vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`
export const DarkPH1 = styled.div`
  position: absolute;
  top: 6vw;
  left: 52%;
  z-index: 1;
  width: 15vw;
  height: 15vw;
  background-image: url(${Dark1Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateY(-10px);
  }
`
export const DarkPH2 = styled.div`
  position: absolute;
  top: 17vw;
  left: 55%;
  z-index: 2;
  width: 17vw;
  height: 12vw;
  background-image: url(${Dark2Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateX(20px);
  }
`
export const DarkPH3 = styled.div`
  position: absolute;
  top: 3vw;
  left: 24%;
  z-index: 3;
  width: 15vw;
  height: 21.5vw;
  background-image: url(${Dark3Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateX(-20px);
  }
`
export const DarkPH4 = styled.div`
  position: absolute;
  top: 13vw;
  left: 40%;
  z-index: 4;
  width: 13vw;
  height: 13vw;
  background-image: url(${Dark4Icon});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 5px 4px rgba(0, 0, 0, 0.25));
  cursor: pointer;
  transition: transform 800ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: translateY(20px);
  }
`

export const BackButton = styled(IconButton)`
  position: absolute !important;
  left: 1rem;
  bottom: 1rem;
  width: 3em;
`

export const BackIcon = styled.img`
  width: 100%;
`

export const DialogContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 3vw;
  padding-bottom: 10vw;
  background-color: #94a7b2;
  display: inline-flex;
  user-select: none;
`
export const ImageHolder = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  gap: 5vw;
`
export const Image = styled.div`
  flex: 1;
  height: 100%;
  background-image: ${({ img }) => `url(${img})`};
  background-size: cover;
  background-position: center;
`
export const TipHolder = styled.div`
  width: 25%;
  height: 100%;
  padding-left: 3vw;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`
export const Tip = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 1vw;
  line-height: 150%;
  color: #0b253c;
  margin: 0;
  padding: 0;
`
export const MarkText = styled.p`
  position: absolute;
  right: 3.5vw;
  bottom: 3vw;
  font-family: NewParisKingSize-Regular;
  font-size: 4vw;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  padding: 0;
`
export const PalText = styled.p`
  position: absolute;
  right: 1.5vw;
  bottom: 2.2vw;
  font-family: OuterSans-Regular;
  font-size: 1.5vw;
  font-weight: 700;
  color: #3a4653;
  margin: 0;
  padding: 0;
`
